import React, {useEffect} from 'react'
import './Roava.css'
import Androidscreenshoot from '../images/Roava/Androidscreenshoot.png'

import Artboard2 from '../images/Roava/Artboard2.png'
import Artboard3 from '../images/Roava/Artboard3.png'
import Artboard4 from '../images/Roava/Artboard4.png'
import Artboard5 from '../images/Roava/Artboard5.png'
import Artboard6 from '../images/Roava/Artboard6.png'
import Artboard7 from '../images/Roava/Artboard7.png'
import Artboard8 from '../images/Roava/Artboard8.png'
import Artboard9 from '../images/Roava/Artboard9.png'
import Artboard10 from '../images/Roava/Artboard10.png'

import Artboard12 from '../images/Roava/Artboard12.png'
import Artboard13 from '../images/Roava/Artboard13.png'

import Artboard14 from '../images/Roava/Artboard14.png'
import Artboard15 from '../images/Roava/Artboard15.png'
import Artboard16 from '../images/Roava/Artboard16.png'
import Artboard17 from '../images/Roava/Artboard17.png'
import Artboard18 from '../images/Roava/Artboard18.png'
import Artboard19 from '../images/Roava/Artboard19.png'
import Artboard20 from '../images/Roava/Artboard20.png'
import Artboard21 from '../images/Roava/Artboard21.png'
import Artboard22 from '../images/Roava/Artboard22.png'
 import Artboard23 from '../images/Roava/Artboard23.png'
import Footer from '../Component/footer'

 /* import Artboard7 from '../images/Roava/Artboard7.png'
     import Artboard23 from '../images/Roava/Artboard23.png'
import Artboard24 from '../images/Roava/Artboard24.png'
import Artboard25 from '../images/Roava/Artboard25.png'
import Artboard26 from '../images/Roava/Artboard26.png'
import Artboard27 from '../images/Roava/Artboard27.png'
import Artboard28 from '../images/Roava/Artboard28.png' */



function Roava() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);

    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Roava">
        <div className="client-role-Roava">
            <h4 className="client-project-Roava">CLIENT</h4>
            <h2 className="portfolio-heading-Roava1"> Roava</h2>
            <h4 className="role-Roava">
            ROLE
            </h4>
            <h2 className="portfolio-role-Roava2">UX Designer</h2>
           </div>
            <h4 className="client-details-Roava"> DETAILS
            </h4>
            <p className="client-details-Roava-p">
            Roava is a digital proposition offering the African diaspora a borderless bank account.
The organization is building a digital bank with a strong focus on cross border payments as its unique selling point. 

            </p>

            <p className="client-details-Roava-p2">
            Applying a design thinking approach/methodology, You are required to create a case study that addresses the design of a mobile app targeted at both the diaspora segment and local Nigerian citizens in need of seamless experience to manage finances in different currencies.  


            </p>
         </div>


       
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard12} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard8} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         
         
         
          <div className="imagevh" id="artboard"><img src={Artboard13} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard14} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard15} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard16} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard17} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard18} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard19} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard20} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard21} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard22} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard23} height="auto" width="100%" alt=""/></div>
         
    {/*
        <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
        <div className="imagevh" id="artboard"><img src={Artboard23} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard24} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard25} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard26} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard27} height="auto" width="100%" alt=""/></div>
    <div className="imagevh" id="artboard"><img src={Artboard28} height="auto" width="100%" alt=""/></div> */}
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}


export default Roava
